import { createSignal } from "solid-js"

const [revision, setRevision] = createSignal(0)

/** Changes whenever a machine may have reported new automations; open readers refetch on it. */
export const automationsRevision = revision

/** A machine reported its automations, or the account stream (re)connected and may have missed a report. */
export function invalidateAutomations() {
  setRevision((value) => value + 1)
}
